import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { SEO } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Motion";
import { GUIDES } from "../data/guides";

const Resources = () => (
  <main data-testid="resources-page">
    <SEO
      title="Welding Repair Guides & Resources | Aledo Welding"
      description="Plain-language guides: gate repair vs. replacement, what to expect from a mobile welding visit, and how to photo damage for a fast, accurate quote."
    />
    <PageHero
      kicker="Guides & resources"
      title="Know before you call — plain answers, no jargon"
      lede="Short guides written for people who don't speak 'welding.' Learn when repair beats replacement, how a mobile visit works, and how to get quoted from photos."
      testidPrefix="resources"
    />
    <section className="bg-paper pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid md:grid-cols-3 gap-px bg-warmline border border-warmline" data-testid="guides-grid">
        {GUIDES.map((g, i) => (
          <Reveal key={g.slug} delay={i * 0.08}>
            <Link to={`/resources/${g.slug}`} data-testid={`guide-card-${g.slug}`} className="group block bg-cream hover:bg-sand transition-colors duration-200 p-7 sm:p-8 h-full">
              <BookOpen size={26} strokeWidth={1.8} className="text-steel mb-5" aria-hidden />
              <h2 className="font-display font-extrabold tracking-tight text-xl leading-snug group-hover:text-rust transition-colors">{g.title}</h2>
              <p className="mt-3 text-smoke text-[15px] leading-relaxed">{g.excerpt}</p>
              <span className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-rust">
                Read the guide <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  </main>
);

export default Resources;
